import {ADD_BOOK, DELETE_BOOK, SET_BOOKS, UPDATE_BOOK} from "../actions/actionTypes";

const initialState = {
  books: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BOOKS:
      return {
        ...state,
        books: action.payload
      };
    case ADD_BOOK:
      return {
        ...state,
        books: state.books.concat(action.payload)
      };
    case DELETE_BOOK:
      return {
        ...state,
        books: state.books.filter(book => book.id !== action.payload)
      };
    case UPDATE_BOOK:
      return {
        ...state,
        books: state.books.map(book => book.id === action.payload.booked_dock ? {...book, responded: false} : book)
      };
    default:
      return state;
  }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/book.js